import React from 'react';
import styled from 'styled-components';
import useEmblaCarousel from "embla-carousel-react";

const EmblaSliderWrap = styled.div`

`;

const EmblaSlider = styled.div`
  position: relative;
`;

const EmblaViewport = styled.div`
  overflow: hidden;
  width: 100%;
  cursor: grab;
`;

export const EmblaContainer = styled.div`
  display: flex;
`;

export const EmblaSlide = styled.div`

`;

const ESlider = ({children}) => {
  const [emblaRef] = useEmblaCarousel({
    dragFree: true,
    align: 'start',
    containScroll: "keepSnaps"
  })

  /*useEffect(() => {
    if (emblaApi) emblaApi.reInit();
  }, [categories])*/

  return (
    <EmblaSliderWrap>
      <EmblaSlider>
        <EmblaViewport ref={emblaRef}>
          <EmblaContainer>{children}</EmblaContainer>
        </EmblaViewport>
      </EmblaSlider>
    </EmblaSliderWrap>
  )
}

export default ESlider;
